import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cc-tag-group',
  templateUrl: 'tag-group.component.html',
  styleUrls: ['home-settings.component.scss'],
})
export class TagGroupComponent {
  selectedList;
  collapse: boolean;
  @Input()
  readonly;

  @Input()
  title;

  @Input()
  isWorking;

  @Input()
  tagGroups;

  @Output()
  add = new EventEmitter();

  @Output()
  edit = new EventEmitter();

  @Output()
  remove = new EventEmitter();

  editTagGroup(tag) {
    this.edit.emit(tag);
  }

  removeTagGroup(id, name) {
    this.remove.emit({ id, name });
  }

  addTagGroup() {
    this.add.emit();
  }
}
